import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PedidoConsultaInternaOutput } from 'src/app/@shared/models/consulta-detalhes-interno';
import { BlocoDetalhesInternosComponent } from '../../bloco-detalhes-internos.component';

@Component({
  selector: 'app-aba-rat',
  templateUrl: './aba-rat.component.html',
  styleUrls: ['./aba-rat.component.scss']
})
export class AbaRatComponent {
  static Title = "RAT";
  static Concluido = (el: FormGroup) => {
    return true;
  }
  @Input('pedido') pedido: PedidoConsultaInternaOutput;
  @Input() parent: BlocoDetalhesInternosComponent;
  constructor(@Inject(MAT_DIALOG_DATA)
  public data: PedidoConsultaInternaOutput) {
    this.pedido = data ?? this.pedido;
  }

}
